<template>
  <div class="ai-chat-content">
    <div
      ref="chatMessagesContainer"
      class="chat-messages-container"
    >
      <ChatWelcome
        @suggestion-click="handleSuggestionClick"
      />
      <ChatMessages
        v-if="messages.length > 0"
      />
    </div>

    <EndedChat
      v-if="isChatEnded && messages.length > 0"
    />

    <SuggestionChips
      v-else
      @suggestion-click="handleSuggestionClick"
      @open-inbox="handleOpenInbox"
    />

    <ChatInput
      ref="chatInputRef"
      :is-thinking="isThinking"
      @message-sent="handleMessageSent"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import ChatWelcome from "./ChatWelcome.vue";
import ChatMessages from "./ChatMessages.vue";
import EndedChat from "./EndedChat.vue";
import ChatInput from "./ChatInput.vue";
import SuggestionChips from "./SuggestionChips.vue";
import { useAutoScroll } from "../../../composables/useAutoScroll";
import { useChat } from "../../../composables/useChat";
const emit = defineEmits(["sendMessage", "suggestionClick", "openInbox"]);
const { messages } = useChat();
const isChatEnded = ref(false);
const chatInputRef = ref();
const { scrollContainerRef: _scrollContainerRef, scrollToBottom: _scrollToBottom } = useAutoScroll(messages, "chatMessagesContainer");
async function handleSuggestionClick(suggestion) {
  emit("suggestionClick", suggestion);
  if (chatInputRef.value) {
    chatInputRef.value.setInputValue(suggestion.text);
    await chatInputRef.value.handleSubmit();
  }
}
function handleOpenInbox() {
  emit("openInbox");
}
function handleMessageSent(message) {
  emit("sendMessage", message);
}
</script>

<style scoped>
.ai-chat-content{display:flex;flex-direction:column;height:70vh;overflow:hidden;padding:4px 16px 16px}.chat-messages-container{display:flex;flex:1;flex-direction:column;min-height:0;overflow-y:auto;scrollbar-width:thin}
</style>
